import CloseIcon from "@mui/icons-material/CloseTwoTone";
import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import ErrorIcon from "../../../assets/images/svgs/face-id-error.svg";
import { ORG_SUBSCRIPTION_PLANS } from "../../../constants/billing.ts";
import { useApiLimitStatus } from "../../../hooks/useApiLimitStatus";
import { useAppStore } from "../../../hooks/useStores.tsx";
import iframeStore from "../../../pages/IframeNew/iframe-store.tsx";
import BriaButton from "../../common/BriaButton/BriaButton.tsx";
import styles from "./ApiLimitReachedBanner.module.scss";

const ApiLimitReachedBanner = () => {
	const { t } = useTranslation("translation", { keyPrefix: "reachedFreeLimitsBanner" });
	const { authStore, pricingStore, uiStore } = useAppStore();
	const { trialEnded, trialAboutToEnd, isAboutToBreakLimit, isUserCreatedBeforeGrowthDate, freeLimit } =
		useApiLimitStatus();

	return (
		<>
			{!iframeStore.isIframe() &&
				(authStore.orgPassedFreeLimit ||
					(isAboutToBreakLimit && !isUserCreatedBeforeGrowthDate) ||
					(isUserCreatedBeforeGrowthDate && trialEnded) ||
					(trialAboutToEnd && !authStore.orgPassedFreeLimit)) &&
				!authStore.isLoadingOrgSubscriptions &&
				authStore.orgSubscription?.plan_name === ORG_SUBSCRIPTION_PLANS.free.name &&
				uiStore.ApiLimitReachedBanner && (
					<Box className={styles.apiLimitReachedBannerContainer}>
						<Box className={styles.content}>
							<img src={ErrorIcon} />
							<Typography
								className={styles.title}
								dangerouslySetInnerHTML={{
									__html: !isUserCreatedBeforeGrowthDate
										? t(authStore.orgPassedFreeLimit ? "actionsTitle" : "warningActionsTitle", {
												limit: freeLimit,
											})
										: t(trialEnded ? "titleLegacy14DayTrial" : "warningTitleLegacy14DayTrial"),
								}}
							/>
							{!isUserCreatedBeforeGrowthDate && (
								<Typography className={styles.description}>{t("description")}</Typography>
							)}
						</Box>
						<BriaButton
							buttonType={"secondaryMedium"}
							onClick={() => {
								pricingStore.openPricingFlow();
							}}
						>
							{t("buttonText")}
						</BriaButton>
						<CloseIcon
							className={styles.closeIcon}
							onClick={() => {
								uiStore.setProperty("ApiLimitReachedBanner", false);
							}}
						/>
					</Box>
				)}
		</>
	);
};

export default observer(ApiLimitReachedBanner);
